import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import { CreateKnowledgeBaseForm } from './CreateKnowledgeBaseForm';

export const CreateKnowledgeBaseModal = ({
  disabled = false,
  onCreate = (() => {}) as (id?: any) => void,
}) => {
  const [open, setOpen] = useState(false);

  const closePopup = () => {
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      <DialogTrigger disabled={disabled} asChild>
        <Button
          variant="outline"
          className={clsx(disabled && 'pointer-events-none opacity-50', 'flex gap-2')}
        >
          <p className="font-medium text-base-xs">Create new</p>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.8"
              d="M6.2 6.2V1H7.8V6.2H13V7.8H7.8V13H6.2V7.8H1V6.2H6.2Z"
              fill="#05050D"
              stroke="#05050D"
              strokeWidth="0.5"
            />
          </svg>
        </Button>
      </DialogTrigger>
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>New Knowledge Base</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <CreateKnowledgeBaseForm close={closePopup} onCreate={onCreate} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
